import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { getDataFromBOU } from '../../Helpers/ApiMethodHelper';



function* getSimplDataResponse({ payload: { offset, limit, search, fromDate, toDate } }) {
  try {
    const response = yield call(getDataFromBOU, `http://localhost:3000/dashboard/api/simpl?billerId=VODA00000MUM03&page=${offset ? offset : 1}&limit=${limit ? limit : 10}${search ? `&search=${search} ` : ''} : ''}`);
    if (response.status === 200) {

      yield put(actions.getSimplDataSuccess(response.data, response.data.total));
    } else {
      yield put(actions.getSimplDataFailed(response.message));
    }
  } catch (error) {
    yield put(actions.getSimplDataFailed(error));
  }
}



export default function* rootSaga() {
  yield all([takeEvery(actions.GET_SIMPL_DATA, getSimplDataResponse)]);

}
